import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.667 1.333H3.333a2 2 0 0 0-2 2v.78a2 2 0 0 0 .167.8v.04c.094.214.228.409.393.574L6 9.607V14a.666.666 0 0 0 .967.593l2.666-1.333a.67.67 0 0 0 .367-.593v-3.06l4.08-4.08c.166-.165.3-.36.393-.574v-.04a2 2 0 0 0 .194-.8v-.78a2 2 0 0 0-2-2M8.86 8.86a.67.67 0 0 0-.193.473v2.92l-1.334.667V9.333a.67.67 0 0 0-.193-.473L3.607 5.333h8.786zM13.333 4H2.667v-.667a.667.667 0 0 1 .666-.666h9.334a.667.667 0 0 1 .666.666z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })